import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../redux/connect';
import { getNotification } from '../../../redux/selectors';
import { resetNotification } from '../../../redux/actions';
import { NotificationManager as NotificationManagerComponent, Tooltip } from '@adsk/bim360-matrix-react-components';

export class PureNotificationManager extends PureComponent {
  componentDidUpdate(prevProps) {
    const { notification, resetNotification } = this.props;

    if (notification && notification !== prevProps.notification) {
      this.notificationManager.addNotification({
        level: notification.level,
        autoDismiss: notification.autoDismiss, //if we don't pass autoDismiss the default is 6 seconds
        type: notification.type,
        message: notification.message,
        asyncOperation: notification.asyncOperation,
        closeButtonRenderer: notification.closeButtonTooltipText
          ? this.getNotificationCloseButtonRenderer(notification.closeButtonTooltipText)
          : undefined,
      });

      // Resetting the notification in the store so that components that rely on the the notification in the store will be updated and won't "remember" an unrelated notification.
      resetNotification();
    }
  }

  setRefIfNeeded = ref => {
    if (!this.notificationManager) {
      this.notificationManager = ref;
    }
  };

  /**
   * Return close button renderer
   * @param closeButtonTooltipText
   * @returns {function({getCloseButton: *, asyncOperationResult?: *})}
   */
  getNotificationCloseButtonRenderer(closeButtonTooltipText) {
    return ({ getCloseButton, asyncOperationResult }) => {
      if (asyncOperationResult && asyncOperationResult.success) {
        return getCloseButton();
      } else {
        return <Tooltip text={closeButtonTooltipText}>{getCloseButton()}</Tooltip>;
      }
    };
  }

  render() {
    return <NotificationManagerComponent ref={this.setRefIfNeeded} />;
  }
}

PureNotificationManager.displayName = 'NotificationManager';

PureNotificationManager.propTypes = {
  notification: PropTypes.object,
  resetNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  notification: getNotification(state),
});

const mapDispatchToProps = () => ({
  resetNotification,
});

export default connect(mapStateToProps, mapDispatchToProps)(PureNotificationManager);

